import { action, makeObservable, observable } from 'mobx';
import { DEFAULT_BASIC_IFRAME_MODAL_LAUNCHER_URL_ENTRIES } from '../constants/BasicIframeModalLauncherConstants';

export class BasicIframeModalLauncherManager {
  constructor() {
    makeObservable(this);
  }

  @observable basicIframeModalLauncherUrlMap = new Map(DEFAULT_BASIC_IFRAME_MODAL_LAUNCHER_URL_ENTRIES);

  // intended to be set via satellite index.js flag or dynamicSatelliteLayout.json config
  @action setBasicIframeModalLauncherUrlMap = (entries = []) => {
    this.basicIframeModalLauncherUrlMap = new Map(entries);
  }
}

export default new BasicIframeModalLauncherManager();
